import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import axios from 'axios'
import config from '@/config/config-esm'

import Header from '@/components/Header'
import MainFlow from '@/components/MainFlow'
import GeoPosition from '@/components/GeoPosition'
import Loading from '@/components/Loading'
import DebugPanel from '@/components/DebugPanel'

import { setFormData } from '@/store/slices/formDataSlice'
import { setAppData } from '@/store/slices/appDataSlice'
import { toggleDebugPanel, addDebugLog } from '@/store/slices/debugSlice'

const Dashboard: React.FC = () => {
  const dispatch = useDispatch()
  const formData = useSelector((state: any) => state.formData)
  const appData = useSelector((state: any) => state.appData)
  
  const [loaded, setLoaded] = useState(false)
  const [dummy, setDummy] = useState(0)

  useEffect(() => {
    document.cookie = 'tminternal=internal;path=/;domain=talkmore.no;max-age=31536000'

    axios
      .get(`${config.newApiUrl}/fieldsales/bootstrap`)
      .then((r) => {
        dispatch(addDebugLog({
          level: 'info',
          message: 'Bootstrap data loaded',
          data: r.data,
          source: 'Dashboard/bootstrap'
        }))
        const { settings } = r.data
        if (settings && Object.keys(settings).length) {
          dispatch(
            setFormData({
              lookupMethod: settings.customer_lookup_method,
              signMethod: settings.customer_sign_method || 'signature',
              geoCollectionMode: settings.geo_collection_mode || 'forced',
            }),
          )
        }
        dispatch(
          setAppData({
            subscriptions: r.data.subscriptions.filter((p: any) => !p.bot_key.startsWith('Familie ')),
            powerPlans: r.data.power_plans,
            campaigns: r.data.campaigns,
            extraServices: r.data.product_options,
            familyDataPackages: r.data.subscriptions.filter((p: any) =>
              p.bot_key.startsWith('Familie '),
            ),
            familyExtraServices: r.data.product_options.filter(
              (p: any) => !p.bot_key.startsWith('Familie '),
            ),
          }),
        )
        setLoaded(true)
      })
      .catch((e) => {
        dispatch(addDebugLog({
          level: 'error',
          message: 'Bootstrap failed',
          data: e,
          source: 'Dashboard/bootstrap'
        }))
        setLoaded(true)
      })
  }, [dispatch])

  const toggleDebugInfo = (ev: React.MouseEvent) => {
    ev.preventDefault()
    dispatch(toggleDebugPanel())
  }

  const toggleDebugMinimized = (ev: React.MouseEvent) => {
    ev.preventDefault()
    if (config.debugSize === 'minimized') {
      window.localStorage.setItem('debug_size', 'normal')
      config.debugSize = 'normal'
    } else {
      window.localStorage.setItem('debug_size', 'minimized')
      config.debugSize = 'minimized'
    }
    setDummy(Math.random())
    dispatch(setFormData({ dummy: Math.random() }))
  }

  const clearStoredState = (ev: React.MouseEvent) => {
    ev.preventDefault()
    window.localStorage.removeItem('_state')
    window.location.reload()
  }

  const content =
    formData.geoSkipped || formData.geoCollectionMode === 'disabled' || formData.latitude ? (
      <MainFlow />
    ) : (
      <GeoPosition />
    )

  return (
    <main className="dashboard">
      <DebugPanel />
      {config.isDebug && (
        <div className="fixed top-4 right-4 z-40">
          <button 
            className="px-4 py-2 bg-gray-800 text-white rounded shadow-lg hover:bg-gray-700 transition-colors"
            onClick={toggleDebugInfo}
          >
            Debug Panel
          </button>
        </div>
      )}
      <Header />
      {loaded && content}
      {!loaded && <Loading />}
    </main>
  )
}

export default Dashboard